import React from 'react';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Carousel } from 'react-responsive-carousel';
import {getCarousel} from '../providers/carousel';

function customArrowPrevRenderer(clickHandler, hasNext, label) {
    return (
        <button className="custom-arrow-prev z-50" onClick={clickHandler}>
            <img src='/assets/arrowleft.svg' alt='' className='md:w-10 md:h-10 w-5 h-5'/>
        </button>
    );
}

function customArrowNextRenderer(clickHandler, hasNext, label) {
    return (
        <button className="custom-arrow-next" onClick={clickHandler}>
            <img src='/assets/arrowright.svg' alt='' className='md:w-10 md:h-10 w-5 h-5'/>
        </button>
    );
}


const CarouselUi = () => {
    const carousel = getCarousel()
            return (
            <>
                <div className='px-1 mx-auto sm:max-w-xl md:max-w-full md:px-24 lg:px-0.5 '>
                    <img src='/assets/universidad_de_verano_1.png' alt='' className='absolute z-10  md:scale-90 md:ml-20 lg:ml-20 scale-40 md:ml-0 -ml-24 md:-mt-0 -mt-7'/>
                    <Carousel infiniteLoop={true} showArrows={true} showThumbs={false} transitionTime={3000} renderArrowPrev={customArrowPrevRenderer} renderArrowNext={customArrowNextRenderer}>
                        {carousel.map(({ src = '', alt = ''}, key) => (
                            <div>
                                <img src={src}
                                     alt={alt}
                                />
                            </div>
                        ))}

                    </Carousel>
                </div>
            </>
    );
};

export default CarouselUi;